export default __webpack_public_path__ + "static/media/news1.0a19b20f.jpg";